module.exports = __webpack_public_path__ + "static/media/auth-manage-buy.3107715d7cda50df45da6b242582cb9d.svg";